import { render, staticRenderFns } from "./MoleculeContentEditorBlockAudio.vue?vue&type=template&id=40cbf660&"
import script from "./MoleculeContentEditorBlockAudio.vue?vue&type=script&lang=js&"
export * from "./MoleculeContentEditorBlockAudio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports